export const AGG_PERIOD = {
    DAILY: { name: 'Daily', code: 'DAILY' },
    WEEKLY: { name: 'Weekly', code: 'WEEKLY' },
    MONTHLY: { name: 'Monthly', code: 'MONTHLY' },
}